import { useNavigate } from 'react-router-dom';
import SingleAccount from '../accounts/components/SingleAccount';
import { useGetUser } from '@/hooks';
import { useEffect } from 'react';

export const settingsRef = '/cdk/settings';
function Settings() {
  const { company } = useGetUser();
  const navigate = useNavigate();
  useEffect(() => {
    if (company?._id) {
      navigate(`${settingsRef}/${company._id}/profile`);
    }
  }, [company?._id, navigate]);

  return <SingleAccount baseUrl={settingsRef} backUrl='/cdk' />;
}

export default Settings;
